import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  attrs: [
    'fp_platform_code',
    'fp_category_code',
    'homepage_order',
    'regions',
    'valid_from',
    'valid_to'
  ],
  titles: [
    store.__('platform'),
    store.__('category'),
    store.__('homepage order'),
    store.__('region'),
    store.__('valid from'),
    store.__('valid to')
  ],
  _sortField: 'fp_platform_code',
  _sortDir: 'ASC',
  initVals: (row) => ({ control_timestamp: Math.round(new Date().getTime()) }),
  validators: {
    homepage_order: [
      Validators.isMandatory(store),
      Validators.positiveInt(store)
    ],
    fp_platform_code: Validators.isMandatory(store),
    fp_category_code: Validators.isMandatory(store),
    regions: [
      Validators.isMandatory(store),
      Validators.regionTest(store)
    ],
    valid_from: [
      Validators.isMandatoryDate(store),
      Validators.isValidFromTo(store)
    ],
    valid_to: [
      Validators.isMandatoryDate(store),
      Validators.isValidFromTo(store)
    ],
    _global: (vals, items) => {
      const validFrom = vals.has('valid_from') && new Date(vals.get('valid_from'))
      const validTo = vals.has('valid_to') && new Date(vals.get('valid_to'))

      // validate distictive intervals of other record with same category
      const overlapping = items.filter((i) => {
        if (vals.get('fp_category_code') !== i.fp_category_code ||
            (vals.get('fp_category_code') === i.fp_category_code && vals.get('regions') !== i.regions) ||
            (i.id && vals.get('id') === i.id) ||
            (i.control_timestamp && i.control_timestamp === vals.get('control_timestamp'))
        ) {
          return // cut off the row with wrong fp_category_code value and current item
        }
        const iFrom = new Date(i.valid_from)
        const iTo = new Date(i.valid_to)
        if (!((iFrom < validFrom) && (iTo < validFrom)) && !((iFrom > validTo) && (iTo > validTo))) {
          // ok
        }
      })

      if (overlapping.length > 0) {
        return overlapping.map((item) => {
          return `${store.__('selected interval overlaps with category:')} ${item.fp_category_code}`
        })
      }
    }
  }
})
